import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoAnexoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarPorIdAnaliseDesconto(idAnaliseDesconto, idCupom?) {

    let parametros = new HttpParams().set('idAnaliseDesconto', idAnaliseDesconto);

    if (idCupom !== null && idCupom !== undefined){
      parametros = parametros.set('idCupom', idCupom);
    }

    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDescontoAnexo/ListarPorIdAnaliseDesconto',
      { params: parametros });
  }

  salvar(analiseDescontoAnexo) {
    return this.http.post(globals.apiUrl + '/api/AnaliseDescontoAnexo/Salvar', analiseDescontoAnexo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/AnaliseDescontoAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
